import client from './client'
import type {
  Invitation,
  SendInvitationPayload,
  PublicInvitation,
  AcceptInvitationPayload,
} from '@/types/team'
import type { User } from '@/types/auth'

const base = (organisationId: number): string =>
  `/organizer/organisations/${organisationId}/invitations`

export async function listInvitations(organisationId: number): Promise<Invitation[]> {
  const { data } = await client.get<{ data: Invitation[] }>(base(organisationId))
  return data.data
}

export async function createInvitation(
  organisationId: number,
  payload: SendInvitationPayload,
): Promise<Invitation> {
  const { data } = await client.post<{ data: Invitation }>(base(organisationId), payload)
  return data.data
}

export async function cancelInvitation(
  organisationId: number,
  invitationId: number,
): Promise<void> {
  await client.delete(`${base(organisationId)}/${invitationId}`)
}

export async function resendInvitation(
  organisationId: number,
  invitationId: number,
): Promise<Invitation> {
  const { data } = await client.post<{ data: Invitation }>(
    `${base(organisationId)}/${invitationId}/resend`,
  )
  return data.data
}

// Public endpoints — no organisation context, token-only
export async function fetchInvitationByToken(token: string): Promise<PublicInvitation> {
  const { data } = await client.get<{ data: PublicInvitation }>(`/accept-invitation/${token}`)
  return data.data
}

export async function acceptInvitation(
  token: string,
  payload: AcceptInvitationPayload,
): Promise<User> {
  const { data } = await client.post<{ data: User }>(`/accept-invitation/${token}`, payload)
  return data.data
}
